<template>
  <v-snackbar
    :timeout="timeout"
    v-model="snackbar"
    top
    right
    class="my-classs"
  >
    <span>{{text}}</span>
    <v-btn dark flat icon color="orange" @click="snackbar = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>

export default {
  data() {
    return {
      type: 'info',
      timeout: 0,
      snackbar: false,
    };
  },
  created() {

  },
  beforeDestroy() {
  },
  methods: {
  },
  computed: {
    text() {
      const { project } = this.$store.state;
      if (project) {
        const { unsupported } = project;
        if (unsupported && unsupported.length > 0) {
          this.snackbar = true;
          let vals = '';
          unsupported.forEach((val) => {
            vals += `${val}, `;
          });
          vals = vals.slice(0, -2);
          return `Disabled video qualities: ${vals}`;
        }
      }
      this.snackbar = false;
      return null;
    },
  },
};
</script>
<style scoped>
.my-class {
  width: 100vw;
}
</style>
